import { useLanguage } from '@/i18n/LanguageContext';

const partners = [
  { 
    name: 'TEKTELIC', 
    category: 'Gateways & Sensors',
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/7da4gys3_tektelic-logo.png'
  },
  { 
    name: 'Viziosense', 
    category: 'Edge AI Cameras',
    logo: 'https://customer-assets.emergentagent.com/job_47fad209-51cc-4d0c-871e-c0ab0b53fdda/artifacts/oxsvmkp3_image.png'
  },
  { 
    name: "SAM'OURAI", 
    category: 'Smart Lockers',
    logo: 'https://customer-assets.emergentagent.com/job_392b8477-61c4-4ec2-baed-14dabc1237cd/artifacts/kclg5weq_image.png'
  },
  { 
    name: 'Adeunis', 
    category: 'Industrial Sensors',
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/my67d693_Adeunis-removebg-preview.png'
  },
  { 
    name: 'Digital Matter', 
    category: 'Asset Trackers',
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/hdz1f0f3_Digital_Matters-removebg-preview.png'
  },
  { 
    name: 'Connected Inventions', 
    category: 'Smart Sensors',
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/g7due9ad_Connected_inventions-removebg-preview.png'
  },
  { 
    name: 'ATIM', 
    category: 'IoT Devices',
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/bb3ao3kq_cropped-atim_logo_browser-1.png'
  },
  { 
    name: 'Dialoc ID', 
    category: 'RFID Solutions',
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/em06fblu_Dialoc_logo__vierkant__400x400-removebg-preview.png'
  },
  { 
    name: 'UnaBiz', 
    category: 'Sigfox Operator',
    logo: 'https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/ywsrfghy_Unabiz-removebg-preview.png'
  },
];

export const DeviceEcosystem = () => {
  const { t } = useLanguage();

  return (
    <section id="devices" className="py-20 md:py-32 bg-white" data-testid="devices-section">
      <div className="container-0g">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <p className="section-label">{t('devices.label')}</p>
          <h2 className="section-title mb-4">
            {t('devices.title')}
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            {t('devices.subtitle')}
          </p>
        </div>

        {/* Partners Grid with Logos */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-9 gap-6 mb-12">
          {partners.map((partner, index) => (
            <div 
              key={index}
              className="flex flex-col items-center justify-center p-6 bg-slate-50 border border-slate-200 rounded-sm hover:border-teal-500 transition-colors group"
              data-testid={`partner-${partner.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className={`h-16 flex items-center justify-center mb-3 ${
                partner.name === "SAM'OURAI" ? 'bg-slate-800 rounded px-2' : ''
              }`}>
                <img 
                  src={partner.logo} 
                  alt={partner.name}
                  className="max-h-16 max-w-full object-contain filter group-hover:brightness-110 transition-all"
                />
              </div>
              <p className="text-xs text-slate-500 text-center">{partner.category}</p>
            </div>
          ))}
        </div>

        {/* Additional Partners Text */}
        <div className="text-center mb-12">
          <p className="text-slate-500">
            {t('devices.alsoPartnering')} <span className="font-semibold text-slate-700">Sigfox, LoRa Alliance</span> {t('devices.andMore')}
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-8 border-t border-slate-200">
          <div className="text-center" data-testid="stat-partners">
            <p className="text-4xl font-bold text-teal-600">10+</p>
            <p className="text-sm text-slate-500 mt-1">{t('devices.technologyPartners')}</p>
          </div>
          <div className="text-center" data-testid="stat-devices">
            <p className="text-4xl font-bold text-teal-600">100+</p>
            <p className="text-sm text-slate-500 mt-1">{t('devices.deviceTypes')}</p>
          </div>
          <div className="text-center" data-testid="stat-networks">
            <p className="text-4xl font-bold text-teal-600">5</p>
            <p className="text-sm text-slate-500 mt-1">{t('devices.networkTechnologies')}</p>
          </div>
          <div className="text-center" data-testid="stat-countries">
            <p className="text-4xl font-bold text-teal-600">3</p>
            <p className="text-sm text-slate-500 mt-1">{t('devices.balticCountries')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
